<template>
  <div
    v-loading="loading"
    class="status"
    element-loading-background="rgba(238, 238, 238, 0.8)"
  >
    <template v-if="data.length">
      <transition-group name="list-complete" tag="div">
        <div
          v-for="d in data"
          :key="d.id"
          class="list-complete-item"
          aria-live="assertive"
        >
          <div v-for="d2 in d.segments" :id="d2.id" :key="d2.id" class="card">
            <h2 class="sr-only">Solicitud {{ d2.id }}</h2>
            <div class="row">
              <div class="col-sm-4">
                <div class="row mb-2 mb-sm-0">
                  <div class="col-5 col-sm-12">
                    <h3>{{ $t("messages.nro-de-ticket") }}</h3>
                  </div>
                  <div class="col-7 col-sm-12">
                    <strong>{{
                      formatTicketNumber(
                        d2.legacy_ticket_number || d.ticket_number
                      )
                    }}</strong>
                  </div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="row mb-2 mb-sm-0">
                  <div class="col-5 col-sm-12">
                    <h3>{{ $t("messages.origen-destino") }}</h3>
                  </div>
                  <div class="col-7 col-sm-12">
                    <div>
                      {{ getAirport(d2.origin) }} -
                      {{ getAirport(d2.destination) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="row mb-2 mb-sm-0">
                  <div class="col-5 col-sm-12">
                    <h3>{{ $t("messages.fecha-de-viaje") }}</h3>
                  </div>
                  <div class="col-7 col-sm-12">
                    <div>
                      {{ formatFlightDate(d2.flight_date) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-sm-4">
                <div class="row mb-2 mb-sm-0">
                  <div class="col-5 col-sm-12">
                    <h3>{{ $t("messages.estado") }}</h3>
                  </div>
                  <div class="col-7 col-sm-12">
                    <el-tooltip
                      v-if="d2.status_description"
                      :content="d.status_description"
                    >
                      <div>
                        <strong>
                          <img
                            src="../../images/bullet.svg"
                            style="margin-bottom: 5px;"
                            alt="bullet icon"
                          />
                          {{ $t("messages." + kebabCase(d2.status)) }}
                        </strong>
                      </div>
                    </el-tooltip>
                    <div v-else>
                      <strong>
                        <img
                          src="../../images/bullet.svg"
                          style="margin-bottom: 5px;"
                          alt="bullet icon"
                        />
                        {{ $t("messages." + kebabCase(d2.status)) }}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="row mb-2 mb-sm-0">
                  <div class="col-5 col-sm-12">
                    <h3>{{ $t("messages.aerolinea") }}</h3>
                  </div>
                  <div class="col-7 col-sm-12">
                    <div>{{ getAirline(d2.airline) }}</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="row mb-2 mb-sm-0">
                  <div class="col-5 col-sm-12">
                    <h3>{{ $t("messages.fecha-de-solicitud") }}</h3>
                  </div>
                  <div class="col-7 col-sm-12">
                    <div>
                      {{ moment(d.created_at).format("DD MMM YYYY") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="d2.status === 'INGRESADO'"
              class="alert latam-retro-alert"
            >
              <img
                src="../../images/avion_card_OLA.svg"
                alt
                class="ml-3 mr-4"
              />
              <div
                v-html="
                  $t('messages.solicitud-acreditada', {
                    airline: getAirline(d2.airline)
                  })
                "
              ></div>
            </div>
            <div
              v-else-if="d2.status === 'EN PROCESO'"
              class="alert latam-retro-alert"
            >
              <img
                src="../../images/avion_card_OLA.svg"
                alt
                class="ml-3 mr-4"
              />
              <div
                v-html="
                  $t('messages.solicitud-en-proceso', {
                    airline: getAirline(d2.airline)
                  })
                "
              ></div>
            </div>
            <div
              v-else-if="d2.status === 'RECHAZADO'"
              class="alert latam-retro-alert"
            >
              <img
                src="../../images/avion_card_OLA.svg"
                alt
                class="ml-3 mr-4"
              />
              <div
                v-html="
                  $t('messages.tu-solicitud-de-millas-no-pudo-ser-procesada')
                "
              ></div>
            </div>
          </div>
        </div>
      </transition-group>
    </template>
    <p v-else>{{ $t("messages.no-hay-retros") }}</p>
  </div>
</template>
<style lang="scss" scoped>
@import "../../scss/variables";
.list-complete-item {
  transition: all 1s;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(-200px);
}
.list-complete-leave-active {
  position: absolute;
}
.card {
  font-size: 20px;
  h3 {
    color: $black;
    font-size: 14px;
  }
  .alert {
    font-size: 14px;
  }
}
</style>

<script>
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import Papa from "papaparse";
import formatTicketNumber from "../Methods/FormatTicketNumber";
import serverBus from "../Bus/ServerBus";
import airlines from "../../data/airlines.json";

export default {
  props: {
    latamId: { type: String, default: null },
    callcenter: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      data: [],
      airportsLoaded: false,
      airlines
    };
  },
  mounted() {
    this.refreshData();

    serverBus.$on("refreshStatus", () => {
      this.refreshData();
    });

    Papa.parse("data/airports.csv", {
      download: true,
      header: true,
      complete: results => {
        this.airports = {};
        results.data.forEach(d => {
          this.airports[d.code] = d.name;
        });
        this.airportsLoaded = true;
      }
    });
  },
  methods: {
    kebabCase: _.kebabCase,
    get: _.get,
    refreshData() {
      this.loading = true;
      axios
        .get(this.callcenter ? "api/v1/callcenter/status" : "api/v1/status", {
          params: { latam_id: this.latamId }
        })
        .then(response => {
          this.loading = false;
          this.data = response.data;
        });
    },
    formatTicketNumber,
    moment,
    formatFlightDate(date) {
      return moment.utc(date).format("DD MMM YYYY");
    },
    getAirport(code) {
      if (!this.airportsLoaded) return code;
      return this.airports[code];
    },
    getAirline(id) {
      return _.get(_.find(this.airlines, { id }), "name", id);
    }
  }
};
</script>
